import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import revenueBySales from "../../../utils/revenueBySales";
import { REACT_APP_ARPS_BASE_URL } from "../../../utils/urls";
import { salesDummy } from "../../../utils/dummy";
import formatShort from "../../../utils/formatShort";
import { Spin } from "antd";

export default function RevenueBySales({ startDate, endDate }: any) {
  const [revenues, setRevenues] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const fetchRevenues = async () => {
    setLoading(true);
    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/revenue/workshop/sales?start=${startDate}&end=${endDate}`
    );
    const data = await response.json();
    const res = revenueBySales(data);
    setRevenues(res);
    setLoading(false);
  };

  useEffect(() => {
    fetchRevenues();
  }, [startDate]);

  const filtered = revenues.filter((revenue: any) => revenue !== undefined);

  const CustomizedLabel = (props: any) => {
    const { x, y, stroke, value } = props;

    return (
      <text
        x={x + 17}
        y={y}
        dy={-4}
        fill={stroke}
        fontSize={10}
        textAnchor={"middle"}
      >
        {/* {value} */}
      </text>
    );
  };

  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center flex-1 mt-8">
        <Spin />
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={300}
        height={540}
        data={loading ? salesDummy : filtered}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis
          tickFormatter={(tick) => {
            return formatShort(tick);
          }}
        />
        <Tooltip />
        <Legend />
        {/* <Bar
          dataKey="net"
          // fill="#008640"
          fill="#15B0BC"
          // barSize={15}
          label={CustomizedLabel}
          name="Net Revenue"
        /> */}

        <Bar
          dataKey="net"
          fill="#15B0BC"
          width={5}
          label={CustomizedLabel}
          name="Net Revenue"
        />
        <Bar
          dataKey="profit"
          fill="#187e85"
          width={5}
          label={CustomizedLabel}
          name="Gross Profit"
        />
        {/* <Bar
          dataKey="profit"
          fill="#15B0BC"
          // barSize={15}
          label={CustomizedLabel}
          name="Gross Profit"
        /> */}
      </BarChart>
    </ResponsiveContainer>
  );
}
